import { Dispatch, FC, useState } from "react";
import { Box, Button, Container, TextField } from "@mui/material";
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import CheckAttr from "../../../utils/CheckAttr";
import ChangeStatusConfirmation from "../../element/ChangeStatusConfirmation";
import { AxiosInstance } from "axios";
import { AlertType } from "../../../types/AlertType";

interface DesactiveDateFormProps {
    http: AxiosInstance;
    url: string;
    confirmMessage: string;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    handleReload: () => void;
    handleClose2: () => void;
}

const DesactiveDateForm: FC<DesactiveDateFormProps> = ({
    http,
    url,
    confirmMessage,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    handleReload,
    handleClose2
}) => {
    const [desactiveDate, setDesactiveDate] = useState<string>();

    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const handleClickDisable = () => {
        if (CheckAttr(desactiveDate)) {
            setOpenConfirmModal(true);
        } else {
            setError(true);
            setAlerteMessage('Merci de choisir une date de désactivation');
            setAlertType("warning");
            setOpenSnack(true);
        }
    };

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false);
    };

    return (
        <>
            <Container maxWidth="lg">
                <TextField
                    label="Choisir la date de désactivation"
                    type="date"
                    color="warning"
                    fullWidth
                    error={error}
                    value={desactiveDate}
                    onChange={(e) => setDesactiveDate(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

                <Box display="flex" justifyContent="center" mt={3}>
                    <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        sx={{ textTransform: 'none' }}
                        endIcon={<RemoveDoneIcon />}
                        onClick={() => handleClickDisable()}
                    >
                        Désactiver
                    </Button>
                </Box>
            </Container>

            <ChangeStatusConfirmation
                url={url}
                http={http}
                desactiveDate={desactiveDate}
                confirmMessage={confirmMessage}
                open={openConfirmModal}
                setError={setError}
                handleClose1={handleCloseConfirmModal}
                handleClose2={handleClose2}
                setOpenSnack={setOpenSnack}
                setAlerteMessage={setAlerteMessage}
                setAlertType={setAlertType}
                handleReload={handleReload}
            />
        </>
    );
};

export default DesactiveDateForm;